import { createContext } from 'react';

import { Vendor, VendorInput } from '@totem/components/vendors/types';

interface Context {
  vendorsLoading: boolean;
  vendorList: string[];
  vendorData: Vendor[];
  rawVendorData: Vendor[];
  action: string;
  actionItem: Vendor;
  onAction?: (action: string, item: Vendor) => void;
  selectedVendors: Vendor[];
  setSelectedVendor: (vendor: Vendor, selected: boolean) => void;
  input: VendorInput;
  setInput: (input: VendorInput) => void;
  addAliasToVendor: (vendorName: string, alias: string, token: string) => void;
}

const VendorLogoContext = createContext<Context>({
  vendorsLoading: true,
  vendorList: [],
  vendorData: [],
  rawVendorData: [],
  action: '',
  actionItem: null,
  onAction: () => {},
  selectedVendors: [],
  setSelectedVendor: () => {},
  input: {},
  setInput: () => {},
  addAliasToVendor: () => {},
});

export default VendorLogoContext;
